<template>
  <div>
    <Content :style="{ padding: '0 24px 16px' }">
      <div class="main-body" id="printMe">
        <div class="select-two main-search">
          <div class="st-block">
            <div class="st-label">机台号</div>
            <div class="st-select">
              <Input
                placeholder="请输入搜索内容"
                v-model="machineNo"
                @keyup.enter.native="getdeviceGroupList()"
                style="width: 300px"
              />
            </div>
          </div>
        </div>
        <div class="button">
          <div class="buttonRow">
            <div class="left">
              <div class="item" @click="refreshData()">
                <i class="iconfont iconicon-shuaxin" />
                刷新
              </div>
              <div
                :class="machineStatus === 0 ? 'machineRunCheck' : 'machineRun'"
                @click="machineFilter(0)"
              >
                <div></div>
                运行（{{ machineRunNumber }}）
              </div>
              <div
                :class="machineStatus === 1 ? 'machineShutdownCheck' : 'machineShutdown'"
                @click="machineFilter(1)"
              >
                <div></div>
                停机（{{ machineShutdownNumber }}）
              </div>
              <div
                :class="machineStatus === 3 ? 'machineMaintenanceCheck' : 'machineMaintenance'"
                @click="machineFilter(3)"
              >
                <div></div>
                维修（{{ machineMaintenanceNumber }}）
              </div>
              <div
                :class="machineStatus === 2 ? 'machineNoPoweredCheck' : 'machineNoPowered'"
                @click="machineFilter(2)"
              >
                <div></div>
                未开机（{{ machineNoPoweredNumber }}）
              </div>
              <div
                :class="machineStatus === 4 ? 'machineOfflineCheck' : 'machineOffline'"
                @click="machineFilter(4)"
              >
                <div></div>
                离线（{{ machineOfflineNumber }}）
              </div>
            </div>
            <div class="right"></div>
          </div>
          <!-- 可以扩展  -->
        </div>
        <div v-if="!loading" class="table-area">
          <div v-for="(item, index) in machineData" class="machineBox" :key="index">
            <div class="boxTitle">
              <div style="font-size: 22px;">
                <div
                  :class="
                    item.machineStatus === 0
                      ? 'machineTitle1'
                      : item.machineStatus === 1
                      ? 'machineTitle2'
                      : item.machineStatus === 2
                      ? 'machineTitle3'
                      : item.machineStatus === 3
                      ? 'machineTitle4'
                      : 'machineTitle5'
                  "
                ></div>
                {{ item.machineNo }}
              </div>
              <div v-if="item.machineStatus === 1" style="color:red">
                {{ item.timeBefore }}停 {{ item.theStopTime }}
              </div>
              <div v-else>{{ item.machineSpeed }}转/分</div>
            </div>
            <div class="boxNameLine">
              <span style="color: #358bf8;">{{ item.workerName || "未上班" }} </span>
              <span> / {{ item.productionCircleSpeed || 0 }}圈</span>
            </div>
            <div class="boxBottom">
              <div>
                <PointerStatus :percent="item.productivity" :status="item.machineStatus" />
              </div>
              <div class="bottomData">
                <div>{{ item.type }}</div>
                <div style="color:#94949d">{{ item.fabricNo }}</div>
                <div>{{ item.fabricName }}</div>
              </div>
            </div>
            <!-- <div class="boxBottom">
              <div class="boxline bottomLine">{{ item.machineSpeed }}转/分</div>
              <div class="boxline bottomLine">
                <div>{{ item.productionCircleSpeed || 0 }}圈</div>
                <div>{{ item.productivity || 0 }}%</div>
              </div>
              <div class="boxline">
                <div>{{ item.runningTimeSpan == null ? "0h" : item.runningTimeSpan }}</div>
                <div>
                  <span style="color:red">停</span>
                  {{ item.theStopTime == null ? "0h" : item.theStopTime }}
                </div>
              </div>
            </div> -->
            <!-- <PointerStatus /> -->
          </div>
        </div>
        <div v-else class="table-area">
          <div class="loadingText">
            加载中。。。
          </div>
        </div>
      </div>
    </Content>
  </div>
</template>

<script>
import PointerStatus from "./pointerStatus.vue";

export default {
  components: { PointerStatus },
  data() {
    return {
      isMin: false,
      machineStatus: -1,
      machineNo: "",
      stopTotalTime: "",
      runningTotalTime: "",
      machineData: [],
      loading: false,
      machineRunNumber: 0,
      machineShutdownNumber: 0,
      machineMaintenanceNumber: 0,
      machineNoPoweredNumber: 0,
      machineOfflineNumber: 0
    };
  },
  created() {
    this.getdeviceGroupList();
    this.getdeviceNumber();
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        this.screenWidth = window.screenWidth;
        if (this.screenWidth > 1600) {
          this.isMin = true;
        } else {
          this.isMin = false;
        }
      })();
    };
  },
  methods: {
    refreshData() {
      this.getdeviceGroupList();
      this.getdeviceNumber();
    },
    machineFilter(number) {
      if (number === 0 && this.machineStatus === 0) {
        this.machineStatus = -1;
      } else if (number === 1 && this.machineStatus === 1) {
        this.machineStatus = -1;
      } else if (number === 2 && this.machineStatus === 2) {
        this.machineStatus = -1;
      } else if (number === 3 && this.machineStatus === 3) {
        this.machineStatus = -1;
      } else if (number === 4 && this.machineStatus === 4) {
        this.machineStatus = -1;
      } else {
        this.machineStatus = number;
      }
      this.getdeviceGroupList();
    },
    getdeviceNumber() {
      const that = this;
      this.axios({
        url: "/dtsum/zongtong/applets/AppletsController/monitorDeviceMessage",
        method: "get",
        params: {
          machineStatus: that.machineStatus,
          machineNo: ""
        }
      })
        .then(res => {
          if (res.data.success) {
            this.machineRunNumber = 0;
            this.machineShutdownNumber = 0;
            this.machineMaintenanceNumber = 0;
            this.machineNoPoweredNumber = 0;
            this.machineOfflineNumber = 0;
            that.machineData.forEach(item => {
              if (item.machineStatus === 0) {
                this.machineRunNumber += 1;
              }
              if (item.machineStatus === 1) {
                this.machineShutdownNumber += 1;
              }
              if (item.machineStatus === 3) {
                this.machineMaintenanceNumber += 1;
              }
              if (item.machineStatus === 2) {
                this.machineNoPoweredNumber += 1;
              }
              if (item.machineStatus === 4) {
                this.machineOfflineNumber += 1;
              }
            });
          }
        })
        .catch(err => {
          that.loading = false;
          console.log(err);
        });
    },
    getdeviceGroupList() {
      this.loading = true;
      const that = this;
      this.axios({
        url: "/dtsum/zongtong/applets/AppletsController/monitorDeviceMessage",
        method: "get",
        params: {
          machineStatus: that.machineStatus,
          machineNo: that.machineNo
        }
      })
        .then(res => {
          if (res.data.success) {
            that.loading = false;
            that.machineData = res.data.body.list;
            that.stopTotalTime = res.data.body.stopTotalTime;
            that.runningTotalTime = res.data.body.runningTotalTime;
          }
        })
        .catch(err => {
          that.loading = false;
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.main-body {
  width: 100%;
  height: 100%;
  // background: rgba(228,235,241,1);
  padding-bottom: 0;
  .select-two {
    // margin-top: 16px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    .st-block {
      height: 36px;
      line-height: 36px;
      display: flex;
      .st-label {
        margin-right: 10px;
      }
      .st-select {
        width: 108px;
        height: 36px;
      }
    }
  }
  .button {
    font-size: $--fontsize-small;
    .buttonRow {
      display: flex;
      justify-content: space-between;
      margin: 10px 0;
      color: #256de6;
      .item {
        display: inline-block;
        cursor: pointer;
      }
      .machineShutdown,
      .machineMaintenance,
      .machineNoPowered,
      .machineOffline,
      .machineRun {
        width: 120px;
        height: 40px;
        line-height: 40px;
        background: #ffffff;
        box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.2);
        border-radius: 11px;
        margin-right: 30px;
        padding: 5px 12rpx;
        box-sizing: border-box;
        text-align: center;
        color: #000;
        user-select: none;
        cursor: pointer;
        div {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #5ccfa8;
        }
      }
      .machineShutdown {
        div {
          background-color: #f68291;
        }
      }
      .machineMaintenance {
        div {
          background-color: #fba078;
        }
      }
      .machineNoPowered {
        div {
          background-color: #c8c7c7;
        }
      }
      .machineOffline {
        div {
          background-color: #4788f6;
        }
      }
      .machineShutdownCheck,
      .machineMaintenanceCheck,
      .machineNoPoweredCheck,
      .machineOfflineCheck,
      .machineRunCheck {
        width: 120px;
        height: 40px;
        line-height: 40px;
        background: #5ccfa8;
        border-radius: 11px;
        margin-right: 30px;
        text-align: center;
        box-sizing: border-box;
        user-select: none;
        cursor: pointer;
        color: #fff;
        div {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #fff;
        }
      }
      .machineShutdownCheck {
        background: #f68291;
      }
      .machineMaintenanceCheck {
        background: #fba078;
      }
      .machineNoPoweredCheck {
        background: #c8c7c7;
      }
      .machineOfflineCheck {
        background: #4788f6;
      }

      .left {
        display: flex;
        height: 50px;
        align-items: center;
        .item {
          margin-right: 30px;
          &:nth-of-type(2) {
            margin-right: 20px;
          }
        }
      }
      .right {
        .item {
          margin-left: 10px;
        }
        .filterButton {
          width: 120px;
          margin-right: 30px;
          height: 32px;
          line-height: 32px;
          text-align: center;
        }
      }
    }
  }
  .table-area {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .loadingText {
      width: 50%;
      text-align: center;
      font-size: 24px;
      color: #000;
      margin-top: 100px;
    }
    .machineBox {
      width: 230px;
      height: 150px;
      border-radius: 15px;
      background: #202133;
      box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.2);
      margin-right: 25px;
      margin-bottom: 20px;
      padding: 5px 15px;
      .boxTitle {
        display: flex;
        justify-content: space-between;
        height: 45px;
        color: #fff;
        .machineTitle2,
        .machineTitle3,
        .machineTitle4,
        .machineTitle5,
        .machineTitle1 {
          width: 10px;
          height: 10px;
          background-color: #5ccfa8;
          border-radius: 50%;
          margin-right: 10px;
        }
        .machineTitle2 {
          background-color: #f68291;
        }
        .machineTitle3 {
          background-color: #c8c7c7;
        }
        .machineTitle4 {
          background-color: #fba078;
        }
        .machineTitle5 {
          background-color: #4788f6;
        }
        div {
          display: flex;
          height: 35px;
          align-items: center;
          text-align: center;
          font-size: 16px;
        }
      }
      .boxNameLine {
        width: 100%;
        text-align: right;
        color: #fff;
      }
      .boxBottom {
        display: flex;
        .bottomData {
          margin-left: 20px;
          color: #fff;
          div:nth-child(1) {
            margin-top: 2px;
          }
          div {
            margin-bottom: 2px;
          }
        }
      }
    }
  }
}
</style>
<style>
.ivu-select-selection .ivu-select-placeholder {
  height: 24px;
  line-height: 24px;
}
.modalGantanhao {
  color: #ff1414;
  margin-right: 12px;
}
.ivu-input {
  background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#fff));
}
</style>
